module.exports = "<div class=\"q-pretty-box pretty-box-border q-no-pad q-marg-bottom-xl\"> <div class=q-section> <div class=\"q-pad-all-md q-bg-c-lightest-grey\"> <h4 class=q-title>{%- header %}</h4> </div> </div> <div class=we-feed-data-display> {%= feedListOnload %} </div> </div>";


//////////////////
// WEBPACK FOOTER
// ./src/components/WidgetEngine/html/globalHtml/feedContainerTemplate.html
// module id = 1134
// module chunks = 1